import React from 'react';

import LoginPage from '@/features/login/pages/login.page';

const LoginRoute = () => {
  return <LoginPage />;
};

export default LoginRoute;
